"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _fieldsMessages = require("../fieldsMessages");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Modal = function Modal(props) {
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var setModalOpen = props.setModalOpen,
    onClickModalClose = props.onClickModalClose;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modalBackground"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "modalContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "body"
  }, /*#__PURE__*/_react.default.createElement("p", null, formatMessage(_fieldsMessages.modalMessages['modalTitle']))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      setModalOpen(false);
    },
    id: "cancelBtn"
  }, formatMessage(_fieldsMessages.modalMessages['modalButtonDisagree'])), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      onClickModalClose();
    }
  }, formatMessage(_fieldsMessages.modalMessages['modalButtonAgree'])))));
};
var _default = Modal;
exports.default = _default;